import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';
import { useUserContext } from 'providers/UserProvider';
import { formatStatus } from 'utils/valueFormatters';
import { getReturnManifestBadgeColor } from 'constants/returnManifest';
import { getShipmentBadgeColor } from 'constants/shipment';
import { TIME_OPTION } from 'constants/time';

export const getReturnManifestListColumns = (tenant, warehouse) => [
  {
    accessorKey: 'return_manifest_code',
    header: 'Return Manifest Code',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, return_manifest_code } = original;

      return (
        <Link to={paths.returns.details(tenant, warehouse, id)}>
          <strong>{return_manifest_code}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'shipping_provider',
    header: 'Shipping Provider',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipping_provider } = original;

      return <span>{shipping_provider?.shipping_provider_type || '-'}</span>;
    },
  },
  {
    accessorKey: 'shipment_quantity',
    header: 'No. of Packages',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { shipment_quantity } = original;

      return <span>{shipment_quantity}</span>;
    },
  },
  {
    accessorKey: 'return_manifest_status',
    header: 'Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { return_manifest_status } = original;

      return (
        <SubtleBadge
          pill
          bg={getReturnManifestBadgeColor(return_manifest_status)}
        >
          {formatStatus(return_manifest_status)}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      meta: {
        valueType: 'string',
      },
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>
          {new Date(created).toLocaleString('en-IN', TIME_OPTION) || '-'}
        </span>
      );
    },
  },
  {
    accessorKey: 'created_by',
    header: 'Generated By',
    meta: {
      meta: {
        valueType: 'string',
      },
    },
    cell: ({ row: { original } }) => {
      const { created_by } = original;

      return <span>{created_by?.email || '-'}</span>;
    },
  },
];

export const RETURN_MANIFEST_DETAIL_SHIPMENT_COLUMNS = [
  {
    accessorKey: 'shipment_code',
    header: 'Shipment Code',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipment_code } = original;

      return <span>{shipment_code}</span>;
    },
  },
  {
    accessorKey: 'order',
    header: 'Order No',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { order } = original;

      return <span>{order.channel_order_id}</span>;
    },
  },
  {
    accessorKey: 'invoice_code',
    header: 'Invoice Code',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { invoice_code } = original;

      return <span>{invoice_code}</span>;
    },
  },
  {
    accessorKey: 'awb_number',
    header: 'AWB Number',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { awb_number } = original;

      return <span>{awb_number}</span>;
    },
  },
  {
    accessorKey: 'shipment_status',
    header: 'Shipment Status',
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { shipment_status } = original;

      return (
        <SubtleBadge pill bg={getShipmentBadgeColor(shipment_status)}>
          {formatStatus(shipment_status)}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'total_gross_amount',
    header: 'Amount',
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { total_gross_amount } = original;

      return <span>{total_gross_amount}</span>;
    },
  },
  {
    accessorKey: 'payment_type',
    header: 'Payment Method',
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { order } = original;

      return <SubtleBadge pill>{order.payment_type}</SubtleBadge>;
    },
  },
];
